import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { Heading } from 'blaze-ui/Heading/Heading'
import { NewDesignButtonV2, NewDocumentButtonV2 } from '../WizardButton/WizardButton'
import { CONTENT_CHANNELS } from '../constants'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { WizardListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'

export const StartBlank = (props: SectionProps) => {
  const { isMobile } = useResponsiveDesign()
  const wizardsHeading = 'Start with a clean slate'

  if (isMobile) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardListItemContainer wizards={CONTENT_CHANNELS} heading={wizardsHeading} withDoc {...props} />
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <Heading level={3}>{wizardsHeading}</Heading>
      <div className={Styles.wizardGroup}>
        <NewDesignButtonV2 size="lg" />
        <NewDocumentButtonV2 size="lg" />
      </div>
    </div>
  )
}
